import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ChangeTitle, toAbsoluteUrl } from "../../helpers/Reusable";
import { apiHeader, postData } from "../../helpers/ApiHelper";

const LegalDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const legalId = location.state?.id || "";
  const [content, setContent] = useState("");
  const [title, setTitle] = useState("");

  ChangeTitle(title || "Legal");

  const fetchDetails = async () => {
    if (!legalId) {
      navigate("/");
      return;
    }

    const param = { legalFlowId: legalId };
    const response = await postData(
      "legalflow/detail",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data;
      if (data.title) setTitle(data.title);
      if (data.description) setContent(data.description);
    } else {
      console.log(response?.data?.message);
    }
  };

  useEffect(() => {
    fetchDetails();
  }, [legalId]);

  return (
    <>
      <div className="w-full p-[5%] min-h-screen bg-yellow">
        <div className="xxl:container mx-auto">
          <div className="w-full mb-[5%] md:mb-[2%]">
            <h1 className="hanson text-center mb-[1%] heading">{title}</h1>
            <img
              className="mb-[2%] mx-auto"
              src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
              alt=""
            />
          </div>
          <div
            className="legal-para"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>
      </div>
    </>
  );
};

export default LegalDetail;
